export default __webpack_public_path__ + "static/media/bathymetryThumb.0a421641.jpg";